import Layout from 'components/Layout'
import MainContentContainer from 'components/MainContentContainer'
import { useMortgageDetails } from 'hooks'

const MortgageDetails = () => {
  const { productId, correlationId } = useMortgageDetails()
  return (
    <Layout>
      <MainContentContainer pageName="Mortgage Results">
        <div>
          <h1>Mortgage Details</h1>
          <p>productId: {productId}</p>
          <p>correlationId: {correlationId}</p>
        </div>
      </MainContentContainer>
    </Layout>
  )
}

export default MortgageDetails
